// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TaskCatalogPageMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TaskCatalogPageMetadataQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string, communitites: Array<{ __typename?: 'Community', id: string, name: string, subdivisions: Array<{ __typename?: 'Subdivision', id: string, name: string }> }> }> }>, globalPlanTags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string }>, enumDetails: { __typename?: 'AllEnumDetails', businessFunctionType: Array<{ __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }> } };

export type TaskCatalogPageMetadata_RegionFragment = { __typename?: 'Region', id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string, communitites: Array<{ __typename?: 'Community', id: string, name: string, subdivisions: Array<{ __typename?: 'Subdivision', id: string, name: string }> }> }> };

export const TaskCatalogPageMetadata_RegionFragmentDoc = gql`
    fragment TaskCatalogPageMetadata_Region on Region {
  ...Named
  markets: children {
    ...Named
    communitites: children {
      ...Named
      subdivisions: children {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export const TaskCatalogPageMetadataDocument = gql`
    query TaskCatalogPageMetadata {
  regions {
    ...TaskCatalogPageMetadata_Region
  }
  globalPlanTags {
    id
    name
  }
  enumDetails {
    businessFunctionType {
      code
      name
    }
  }
}
    ${TaskCatalogPageMetadata_RegionFragmentDoc}`;

/**
 * __useTaskCatalogPageMetadataQuery__
 *
 * To run a query within a React component, call `useTaskCatalogPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogPageMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskCatalogPageMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskCatalogPageMetadataQuery, TaskCatalogPageMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogPageMetadataQuery, TaskCatalogPageMetadataQueryVariables>(TaskCatalogPageMetadataDocument, options);
      }
export function useTaskCatalogPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogPageMetadataQuery, TaskCatalogPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogPageMetadataQuery, TaskCatalogPageMetadataQueryVariables>(TaskCatalogPageMetadataDocument, options);
        }
export function useTaskCatalogPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogPageMetadataQuery, TaskCatalogPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogPageMetadataQuery, TaskCatalogPageMetadataQueryVariables>(TaskCatalogPageMetadataDocument, options);
        }
export type TaskCatalogPageMetadataQueryHookResult = ReturnType<typeof useTaskCatalogPageMetadataQuery>;
export type TaskCatalogPageMetadataLazyQueryHookResult = ReturnType<typeof useTaskCatalogPageMetadataLazyQuery>;
export type TaskCatalogPageMetadataSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogPageMetadataSuspenseQuery>;
export type TaskCatalogPageMetadataQueryResult = Apollo.QueryResult<TaskCatalogPageMetadataQuery, TaskCatalogPageMetadataQueryVariables>;